<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" ref="view"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" ref="view"></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
#app {
  min-height: 100vh;
}
</style>
